import { createContext, useContext } from 'react';

// Set by a host that leaves some of the card's own buttons out, such as Chat on a card the user already has a chat
// about. Each entry is the end of a button's element id, as `-card_chat`
export const HostHiddenActionsContext = createContext<readonly string[]>([]);

export const useHostHiddenActions = () => useContext(HostHiddenActionsContext);
